var PaymentMethodCode;
(function (PaymentMethodCode) {
    PaymentMethodCode["COD"] = "COD";
    PaymentMethodCode["COD_OFFLINE"] = "COD_OFFLINE";
    PaymentMethodCode["VNPAYQR"] = "VNPAYQR";
    PaymentMethodCode["VNPAY_GATEWAY"] = "VNPAY_GATEWAY";
    PaymentMethodCode["VNPAY_QRCODE"] = "VNPAY_QRCODE";
    PaymentMethodCode["CTT"] = "CTT";
    PaymentMethodCode["MOBILE_BANKING"] = "MOBILE_BANKING";
    PaymentMethodCode["LOYALTY"] = "LOYALTY";
    PaymentMethodCode["CASH"] = "CASH";
    PaymentMethodCode["VNPAY_TOKEN"] = "VNPAY_TOKEN";
    PaymentMethodCode["ALEPAY_INSTALLMENT_CREDIT"] = "ALEPAY_INSTALLMENT_CREDIT";
    PaymentMethodCode["VNPAY_INSTALLMENT_CREDIT"] = "VNPAY_INSTALLMENT_CREDIT";
    PaymentMethodCode["PAYBILL"] = "PAYBILL";
})(PaymentMethodCode || (PaymentMethodCode = {}));
var PaymentMethodGroupCode;
(function (PaymentMethodGroupCode) {
    PaymentMethodGroupCode["CREDIT"] = "CREDIT";
    PaymentMethodGroupCode["INSTALLMENT"] = "INSTALLMENT";
    PaymentMethodGroupCode["CARD"] = "CARD";
    PaymentMethodGroupCode["OFFLINE"] = "OFFLINE";
    PaymentMethodGroupCode["LOYALTY"] = "LOYALTY";
})(PaymentMethodGroupCode || (PaymentMethodGroupCode = {}));
var PaymentCardType;
(function (PaymentCardType) {
    PaymentCardType[PaymentCardType["REDIRECT_URL_THANH_TOAN"] = 1] = "REDIRECT_URL_THANH_TOAN";
    PaymentCardType[PaymentCardType["GEN_QR_CONG"] = 2] = "GEN_QR_CONG";
})(PaymentCardType || (PaymentCardType = {}));

export { PaymentCardType, PaymentMethodCode, PaymentMethodGroupCode };
